import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Watch } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import { addYears, format, parse } from "date-fns";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { Guid } from "guid-typescript";
import { AssetMasterModule } from "@/store/modules/asset.module";
import AssetTypePropertyComponent from "./components/AssetTypePropertyComponent.vue";
import { interpret } from "xstate";
import editAssetMachine from "./machines/EditAssetMachine";
import Switches from "vue-switches";
import Loader from "../../../components/widgets/loader.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import { DateFormatConstant } from "@/store/DateFormatConstants";
/**
 * Edit Asset Components
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let EditAsset = /** @class */ (() => {
    let EditAsset = class EditAsset extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.ctaButtons = [{ routeName: "assetManager" }];
            this.statusId = "";
            this.confirmAssignmentModal = false;
            this.showRepairNotesBeforeServicesModal = false;
            this.showDisposeConfirmation = false;
            this.showRepairNotesAfterServiceModal = false;
            this.isValueInternallySet = false;
            this.title = "Edit Asset";
            this.machine = editAssetMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Asset Manager",
                    to: "/assetManager",
                },
                {
                    text: "Edit Asset",
                    active: true,
                },
            ];
        }
        send(event) {
            this.machineService.send(event);
        }
        repairStatusChanged(newval, oldval) {
            if (!this.isValueInternallySet) {
                if (oldval) {
                    if (!newval) {
                        this.machineService.send({ type: "RECEIVED_FROM_REPAIR" });
                    }
                }
                else {
                    this.machineService.send({ type: "SENT_FOR_REPAIR" });
                }
            }
            else {
                this.isValueInternallySet = false;
            }
        }
        cancelModal() {
            this.assetDetail.statusId = this.constant.Assigned();
            this.machineService.send({ type: "CANCEL_CONFIRM_STATUS" });
        }
        confirmModal() {
            this.machineService.send({ type: "CONFIRM_STATUS_CHANGE" });
        }
        statusChanged(newValue, oldValue) {
            if (oldValue == this.constant.Assigned()) {
                this.machineService.send({ type: "CHANGE_STATUS" });
            }
        }
        saveRepairNotesBeforeService() {
            this.validate("repairNotesBeforeServiceObserver").then((response) => {
                if (response) {
                    var price = this.assetDetail.price;
                    this.assetDetail.price = Number(price);
                    this.machineService.send({
                        type: "SAVE_REPAIR_NOTES_BEFORE_SERVICE",
                        payload: this.assetDetail,
                    });
                }
            });
        }
        cancelRepairNotesBeforeService() {
            this.assetDetail.repairNotesBeforeService = null;
            this.assetDetail.sentToRepairOnAsString = null;
            this.assetDetail.statusId = this.statusId;
            this.machineService.send({ type: "CANCEL_REPAIR_NOTES_BEFORE_SERVICE" });
        }
        disabledAfterToday(date) {
            if (this.assetDetail.dateOfPurchaseThreshold == null) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return date > today;
            }
            const lockDate = new Date(this.assetDetail.dateOfPurchaseThreshold);
            return date > lockDate;
        }
        saveRepairNotesAfterService() {
            this.validate("repairNotesAfterServiceFocusObserver").then((response) => {
                if (response) {
                    var price = this.assetDetail.price;
                    this.assetDetail.price = Number(price);
                    this.machineService.send({
                        type: "SAVE_REPAIR_NOTES_AFTER_SERVICE",
                        payload: this.assetDetail,
                    });
                }
            });
        }
        cancelRepairNotesAfterService() {
            this.assetDetail.statusId = this.assetDetail.repairNotesAfterService = null;
            this.assetDetail.returnedFromRepairOnAsString = null;
            this.assetDetail.statusId = this.statusId;
            this.machineService.send({ type: "CANCEL_REPAIR_NOTES_AFTER_SERVICE" });
        }
        updateAsset() {
            this.validate("editAssetObserver").then((response) => {
                if (response) {
                    this.assetDetail.assetProperties = this.assetProperties;
                    var price = this.assetDetail.price;
                    this.assetDetail.price = Number(price);
                    this.assetDetail.dateOfPurchase = null;
                    this.machineService.send({
                        type: "UPDATE_ASSET",
                        payload: this.assetDetail,
                    });
                }
            });
        }
        cancel() {
            this.machineService.send({ type: "CANCEL_EDIT_ASSET" });
            this.assetDetail.statusId = this.assetDetail.statusId;
            this.$router.push({ name: "assetManager" });
            this.assetDetail.repairStatus = false;
        }
        changeAssetType(assetTypeId) {
            AssetMasterModule.clearGetAssetPropertiesValues();
            var assetType = AssetMasterModule.assetsType.filter((x) => x.id == assetTypeId);
            for (var i = 0; i < this.assetCategory.length; i++) {
                var category = this.assetCategory[i];
                var categories = assetType.filter((x) => x.assetCategoryId == category.id.toString());
                if (categories.length > 0) {
                    this.assetDetail.assetCategoryName = category.value;
                }
            }
            AssetMasterModule.GetAssetTypePropertiesByAssetTypeId(assetTypeId).then((response) => {
                if (response) {
                    this.assetTypeId = this.assetTypeId;
                    this.assetDetail.assetProperties = this.assetProperties;
                }
            });
        }
        calculateEndDate() {
            this.assetDetail.warrantyPeriod = parseInt(this.newNumber);
            if (this.newNumber === "") {
                this.assetDetail.warrantyEndDateAsString = "";
            }
            else if (this.assetDetail.warrantyStartDateAsString === null) {
                this.assetDetail.warrantyEndDateAsString = "";
            }
            else if (this.assetDetail.warrantyPeriod >= 0) {
                const inputDateFormat = this.dateFormat === DateFormatConstant.DateFormat.DateFormatDMY() ? DateFormatConstant.DateFormatClientDMY() : DateFormatConstant.DateFormatClientMDY();
                const warrantyStartDate = parse(this.assetDetail.warrantyStartDateAsString, inputDateFormat, new Date());
                const warrantyEndDate = addYears(warrantyStartDate, this.assetDetail.warrantyPeriod);
                this.assetDetail.warrantyEndDateAsString = format(warrantyEndDate, inputDateFormat);
            }
        }
        calculateWarrantyDate(date) {
            if (this.dateFormat === DateFormatConstant.DateFormat.DateFormatMDY()) {
                this.assetDetail.warrantyStartDate = parse(date, "MM/dd/yyyy", new Date());
                this.assetDetail.warrantyStartDateAsString = this.dateFormattedString(this.assetDetail.warrantyStartDate);
            }
            else {
                this.assetDetail.warrantyStartDate = parse(date, "dd/MM/yyyy", new Date());
                this.assetDetail.warrantyStartDateAsString = this.dateFormatted(this.assetDetail.warrantyStartDate);
            }
            this.calculateEndDate();
        }
        disabledEarliestDay(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (date > today) {
                return true;
            }
            const purchaseDate = this.parseDate(this.assetDetail.dateOfPurchase);
            return date < purchaseDate;
        }
        parseDate(dateString) {
            let date;
            if (dateString.includes("T")) {
                date = new Date(dateString);
            }
            else {
                const parts = dateString.split("/");
                if (parts.length === 3) {
                    let day, month, year;
                    if (this.dateFormat === DateFormatConstant.DateFormat.DateFormatMDY()) {
                        month = parseInt(parts[0], 10);
                        day = parseInt(parts[1], 10);
                        year = parseInt(parts[2], 10);
                    }
                    else if (this.dateFormat === DateFormatConstant.DateFormat.DateFormatDMY()) {
                        day = parseInt(parts[0], 10);
                        month = parseInt(parts[1], 10);
                        year = parseInt(parts[2], 10);
                    }
                    date = new Date(`${year}-${month}-${day}`);
                }
            }
            return date;
        }
        calculatePrice() {
            var newnumber = new Number(this.assetDetail.price).toFixed(2);
            this.assetDetail.price = newnumber;
        }
        disabledStatusLockDate(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (date > today) {
                return true;
            }
            const lockdate = this.assetDetail.lastStatusThreshold ? new Date(this.assetDetail.lastStatusThreshold) : null;
            lockdate.setHours(0, 0, 0, 0);
            return lockdate ? date < lockdate : false;
        }
        get assetDetail() {
            return AssetMasterModule.assetDetail;
        }
        get assetStatus() {
            return AssetMasterModule.getAssetStatusType;
        }
        get assetCategory() {
            return AssetMasterModule.assetCategory;
        }
        get assetControlTypes() {
            return AssetMasterModule.getAssetControlType;
        }
        get vendors() {
            return AssetMasterModule.vendors;
        }
        get assetTypes() {
            return AssetMasterModule.assetTypes;
        }
        get assetProperties() {
            return AssetMasterModule.getAssetProperties;
        }
        get assetLocations() {
            return AssetMasterModule.assetLocations;
        }
        get canEditAssetTypeProperties() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanEditAssetTypeProperties());
        }
        get canEditAssetDetails() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanEditAssetDetails());
        }
        get disbledAsset() {
            return this.constant.Scrap() == this.statusId;
        }
        //Lifecycle
        created() {
            AssetMasterModule.clearGetAssetProperties();
            this.assetId = Guid.parse(this.$route.params.assetId);
            this.machineService.machine.context.assetId = this.assetId;
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                this.newNumber = this.assetDetail.warrantyPeriod.toString();
                if (this.state.matches("gettingEditAssetsDetails") || this.state.matches("loadedEditAssets")) {
                    this.$bvModal.hide("assignmentModal");
                    this.$bvModal.hide("repairNotesBeforeServiceModal");
                    this.$bvModal.hide("repairNotesAfterServiceModal");
                }
                if (previousState.matches("gettingEditAssetsDetails") && this.state.matches("loadedEditAssets")) {
                    this.statusId = this.assetDetail.statusId;
                }
                if (this.state.matches("changeStatus")) {
                    this.$bvModal.show("assignmentModal");
                }
                if (this.state.matches("sentRepairStatus")) {
                    this.$bvModal.show("repairNotesBeforeServiceModal");
                }
                if (this.state.matches("loadedEditAssets") && previousState.matches("sentRepairStatus")) {
                    this.isValueInternallySet = true;
                    this.assetDetail.repairStatus = false;
                }
                if (this.state.matches("loadedEditAssets") && previousState.matches("receivedRepairStatus")) {
                    this.isValueInternallySet = true;
                    this.assetDetail.repairStatus = true;
                }
                if (this.state.matches("receivedRepairStatus")) {
                    this.$bvModal.show("repairNotesAfterServiceModal");
                }
                if (this.state.matches("gettingListAssetsDetails")) {
                    this.$router.push({ name: "assetManager" });
                }
            });
        }
        destroyed() {
            this.machineService.stop();
            AssetMasterModule.clearGetAssetProperties();
        }
        disposeAsset() {
            this.showDisposeConfirmation = false;
        }
        cancelDispose() {
            this.assetDetail.statusId = this.constant.Scrap();
            this.showDisposeConfirmation = false;
        }
        checkRepair(Id) {
            if (Id == this.constant.Repair()) {
                this.assetDetail.repairStatus = true;
                return;
            }
            if (Id == this.constant.Disposed()) {
                this.showDisposeConfirmation = true;
                return;
            }
            else {
                this.assetDetail.repairStatus = false;
                this.showDisposeConfirmation = false;
                return;
            }
        }
    };
    __decorate([
        Watch("assetDetail.repairStatus"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], EditAsset.prototype, "repairStatusChanged", null);
    __decorate([
        Watch("assetDetail.statusId"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], EditAsset.prototype, "statusChanged", null);
    EditAsset = __decorate([
        Component({
            name: "EditAsset",
            components: {
                Layout,
                PageHeader,
                AssetTypePropertyComponent,
                Switches,
                Loader,
                DeleteComponent,
            },
        })
    ], EditAsset);
    return EditAsset;
})();
export default EditAsset;
